exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-61093596] {\n  max-width: 300px;\n  max-height: 300px;\n  width: 100%;\n  height: auto;\n}\n@media (min-width: 1280px) {\nimg[data-v-61093596] {\n    max-width: 384px;\n    max-height: 384px;\n}\n}\nh2[data-v-61093596] {\n  line-height: 1.25;\n}\n@media (min-width: 1024px) {\nh2[data-v-61093596] {\n    line-height: 70px;\n}\n}", ""]);

// exports
